const state = {
    departments: [],
    departmentId: [],
    loading: false
};

export default state;